import { FunctionComponent, ReactNode } from "react";
import styles from "./SteppersMarker.module.css";
import {
  LabelPairedCheckCaptionBoldIcon,
  LabelPairedCheckMdBoldIcon,
  LabelPairedCheckSmBoldIcon,
  LabelPairedExclamationCaptionBoldIcon,
  LabelPairedExclamationMdBoldIcon,
  LabelPairedExclamationSmBoldIcon,
  LabelPairedXmarkCaptionBoldIcon,
  LabelPairedXmarkMdBoldIcon,
  LabelPairedXmarkSmBoldIcon,
  LabelPairedCircleXmarkCaptionFillIcon,
  LabelPairedCircleXmarkMdFillIcon,
  LabelPairedCircleXmarkLgFillIcon,
  LabelPairedCircleExclamationCaptionFillIcon,
  LabelPairedCircleExclamationMdFillIcon,
  LabelPairedCircleExclamationLgFillIcon,
} from "@deriv/quill-icons";

export type SteppersMarketType = {
  className?: string;
  text?: number | string;
  size?: "sm" | "md" | "lg";
  type?: "inactive" | "inprogress" | "complete";
  marker?: "dot" | "number" | "icon";
  indicator?: "default" | "fail" | "warning";
  icon?: ReactNode;
};

const SteppersMarkerAtom: FunctionComponent<SteppersMarketType> = ({
  className = "",
  size = "sm",
  type = "inactive",
  marker = "dot",
  text = "1",
  indicator = "default",
  icon,
}) => {
  const icons = {
    complete: {
      sm: <LabelPairedCheckCaptionBoldIcon />,
      md: <LabelPairedCheckSmBoldIcon />,
      lg: <LabelPairedCheckMdBoldIcon />,
    },
    fail: {
      sm: <LabelPairedXmarkCaptionBoldIcon />,
      md: <LabelPairedXmarkSmBoldIcon />,
      lg: <LabelPairedXmarkMdBoldIcon />,
    },
    warning: {
      sm: <LabelPairedExclamationCaptionBoldIcon />,
      md: <LabelPairedExclamationSmBoldIcon />,
      lg: <LabelPairedExclamationMdBoldIcon />,
    },
    icon: {
      fail: {
        sm: <LabelPairedCircleXmarkCaptionFillIcon />,
        md: <LabelPairedCircleXmarkMdFillIcon />,
        lg: <LabelPairedCircleXmarkLgFillIcon />,
      },
      warning: {
        sm: <LabelPairedCircleExclamationCaptionFillIcon />,
        md: <LabelPairedCircleExclamationMdFillIcon />,
        lg: <LabelPairedCircleExclamationLgFillIcon />,
      },
    },
  };

  let content = null;

  if (marker === "number") {
    content = <b className={styles.number}>{text}</b>;
  }
  if (type === "complete") {
    content = icons.complete[size];
  }
  if (indicator === "fail" || indicator === "warning") {
    content = icons[indicator][size];
  }

  if (marker === "icon") {
    content = icon;

    if (indicator === "fail" || indicator === "warning") {
      content = icons.icon[indicator][size];
    }

    return (
      <div
        className={[styles.icon, className].join(" ")}
        data-size={size}
        data-type={type}
        data-indicator={indicator}
      >
        {content}
      </div>
    );
  }

  return (
    <div
      className={[styles.root, className].join(" ")}
      data-size={size}
      data-type={type}
      data-indicator={indicator}
    >
      {content && content}
    </div>
  );
};

export default SteppersMarkerAtom;
